import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, getUtility, Icon } from '@livable/saas-react-components';
import { Skeleton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RippleEffect from 'src/components/general/RippleEffect';
import useStyles from '../styles';
import { isValueNumber } from 'src/utils/typeValidators';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
export const BillingOptOutCell = observer(_ref => {
  var _params$row$residency, _store$properties$get;
  let params = _ref.params;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCap = _useState2[0],
    setIsCap = _useState2[1];
  const getBillingOptIds = (arr1, arr2) => {
    const unique1 = arr1.map(u => u.utilityId).filter(u => arr2.indexOf(u.utilityId) === -1);
    const unique2 = arr2.filter(u => arr1.indexOf(u) === -1);
    return unique1.concat(unique2);
  };
  const billingOptOutIds = getBillingOptIds(params.row.residencyUtilityOptOuts, params.row.unitUtilityOptOuts.map(i => i.utilityId) || []);
  const Utilities = observer(_ref2 => {
    let haveToBePaid = _ref2.haveToBePaid;
    let utilities = [];
    if (haveToBePaid) {
      utilities = params.row.residencyUtilities;
    } else {
      billingOptOutIds.map(item => {
        var _store$homeDashboardS, _store$homeDashboardS2;
        utilities.push({
          utilityType: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.getUtilityInfoById(item)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.name) || ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.getUtilityInfoById(item)) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.utilityTypeName),
          utilityId: item
        });
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t("residencies_page.".concat(haveToBePaid ? 'resident_pays_for' : 'resident_does_not_pay_for')))), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, utilities.map(item => {
      const icon = getUtility((item === null || item === void 0 ? void 0 : item.utilityType) || item.utilityTypeName).icon();
      return /*#__PURE__*/React.createElement("div", {
        className: classes.billingOpt,
        key: item.utilityId
      }, icon, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, (item === null || item === void 0 ? void 0 : item.utilityType) || item.utilityTypeName, ' ', isValueNumber(item.utilityCap) && /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        component: 'span'
      }, t("residencies_page.cap_amount", {
        amount: Number(item.utilityCap).toFixed(2)
      })))));
    })));
  });
  const TooltipBillingOutBody = /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContainer
  }, (_params$row$residency = params.row.residencyUtilities) !== null && _params$row$residency !== void 0 && _params$row$residency.length ? /*#__PURE__*/React.createElement("div", {
    className: classes.successBlock
  }, /*#__PURE__*/React.createElement(Utilities, {
    haveToBePaid: true
  })) : null, !(billingOptOutIds !== null && billingOptOutIds !== void 0 && billingOptOutIds.length) ? null : /*#__PURE__*/React.createElement(Utilities, null), params.row.statementCap !== null ? /*#__PURE__*/React.createElement("div", {
    className: classes.successBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-header"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('enrollment_modal.statement_cap'), ": ", "$".concat(Number(params.row.statementCap).toFixed(2))))) : null);
  useEffect(() => {
    const hasCap = params.row.residencyUtilities.some(item => isValueNumber(item.utilityCap));
    setIsCap(hasCap);
  }, [params.row.residencyUtilities]);
  if ((_store$properties$get = store.properties.getPropertyUtilityProvidersV3Async) !== null && _store$properties$get !== void 0 && (_store$properties$get = _store$properties$get.inProgressUnicIds) !== null && _store$properties$get !== void 0 && _store$properties$get.includes(params.row.propertyId)) {
    return /*#__PURE__*/React.createElement(Skeleton, {
      variant: "text",
      animation: "wave",
      width: 80,
      height: 24
    });
  } else if (!params.row.accountId) {
    return /*#__PURE__*/React.createElement("span", {
      className: classes.disabledCellText
    }, "N/A");
  } else {
    var _params$row, _store$homeDashboardS3, _store$homeDashboardS4;
    return /*#__PURE__*/React.createElement(ExpandedTooltip, {
      id: "ExpandedTooltip-".concat(params.row.propertyId, "-").concat(params.row.accountId),
      key: "ExpandedTooltip-".concat(params.row.propertyId, "-").concat(params.row.accountId),
      className: classes.tooltip,
      disableInteractive: true,
      hideOnMobile: true,
      placement: "top",
      title: TooltipBillingOutBody,
      type: "utilities-default"
    }, /*#__PURE__*/React.createElement("div", {
      id: "".concat(params.row.propertyId, "-").concat(params.row.accountId),
      key: "".concat(params.row.propertyId, "-").concat(params.row.accountId),
      className: classes.rippleContainer
    }, /*#__PURE__*/React.createElement(RippleEffect, {
      className: "".concat((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
    }, isCap && /*#__PURE__*/React.createElement("i", {
      className: classes.capIcon
    }, /*#__PURE__*/React.createElement("i", null, "U"), /*#__PURE__*/React.createElement(Icon, {
      type: "upper-limit"
    })), params.row.statementCap !== null && /*#__PURE__*/React.createElement("i", {
      className: classes.capIcon
    }, /*#__PURE__*/React.createElement("i", null, "S"), /*#__PURE__*/React.createElement(Icon, {
      type: "upper-limit"
    })), ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany.propertyDetails(params.row.propertyId)) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'billingTemplatesList' : 'utilityTemplatesList']) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.length) - (billingOptOutIds === null || billingOptOutIds === void 0 ? void 0 : billingOptOutIds.length), "/", (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany.propertyDetails(params.row.propertyId)) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details[store.account.featureFlagsStore.getIsBillingTemplatesEnabled ? 'billingTemplatesList' : 'utilityTemplatesList']) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.length)));
  }
});